export const version = "abstract-signer/5.6.0";
//# sourceMappingURL=_version.js.map